import { render, staticRenderFns } from "./Wbbook.vue?vue&type=template&id=779d6d06&scoped=true&"
import script from "./Wbbook.vue?vue&type=script&lang=js&"
export * from "./Wbbook.vue?vue&type=script&lang=js&"
import style0 from "./Wbbook.vue?vue&type=style&index=0&id=779d6d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d6d06",
  null
  
)

export default component.exports